import { render, staticRenderFns } from "./ChangeMembership.vue?vue&type=template&id=42726205&"
import script from "./ChangeMembership.vue?vue&type=script&lang=ts&"
export * from "./ChangeMembership.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports